import { Api } from '@/services/Api';

export default {
/*  1. Get all data */
    GetBranches(body = { keyword: '' }) {
        return Api().post('/Branch/GetBranchs', body);
    },

    /* 6. Get by keyword*/
    getBranches(keyword = '') {
        var body = { keyword: keyword }
        return Api().post('/Branch/GetBranchs', body);
    },

    /*  2. Get one column */
    getBranch(id) {
        return Api().get(`/Branch/${id}`);
    }, 

     /*  3. Create one column */
    saveBranch(body) {
        return Api().post(`/Branch`, body);
    },

    /*  4. Delete one or more columns */
    deleteBranches(branches) {
        return Api().post(`/Branch/DeleteBranch`, branches);
    },

     /*  5. post one or more columns */
    postBranches( branches   ) {
        return Api().post(`/Branch/PostBranch`, branches);
    },
}